




import { Component, Vue } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import { ApiAuth } from '@/store/types/IRootState';

const { VUE_APP_DATABASE_IMAGE_DIRECTORY } = process.env;
const directory = VUE_APP_DATABASE_IMAGE_DIRECTORY || 'banco_imagens';

@Component({
  props: {
    src: Array,
  },
})
export default class ItemImage extends Vue {
  @State
  public auth!: ApiAuth;
  @Mutation
  public setPreviewImage!: (url: string) => any;

  get imageName(): any {
    return (this.$props.src || []).filter((name: string) => name.split('.').slice(-1)[0].match(/(jpg|png|img)/))[0];
  }

  get imageUrl(): string {
    const { user } = this.auth;
    return `${user && user.url_base}${directory}/${this.imageName}`;
  }

  public setPreviewUrl() {
    this.setPreviewImage(this.imageUrl);
  }
}
